module.exports = __webpack_public_path__ + "img/chinesecompany31.05e2e53c.png";